export default class ShopTheme extends HTMLElement {
    private color: string = ''
    private background: boolean = false
    private backgroundColor: string = ''

    static get observedAttributes() {
        return ['color', 'background', 'background-color']
    }

    constructor() {
        super()

        this.color = this.getAttribute('color') || ''
        this.background = this.getAttribute('background') === 'true' ? true : false
        this.backgroundColor = this.getAttribute('background-color') || ''
    }

    connectedCallback() {
        this.updateTheme()
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name === 'color' && oldValue !== newValue) {
            this.updateTheme()
        }
    }

    private updateTheme() {
        if (this.color) {
            document.documentElement.style.setProperty('--theme-color', this.color)
            document.querySelector('header')?.style.setProperty('color', this.color)
        }

        if (this.background) {
            document.documentElement.style.setProperty('--theme-background', this.backgroundColor)
            document.body.style.backgroundColor = this.backgroundColor
        }
    }
}

customElements.define('shop-theme', ShopTheme)
